import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import { pageAccessGuard } from '../guard/page-access.guard';

const routes: Routes = [{ path: '', component: HomePageComponent,
canActivate: [pageAccessGuard],
data: {
  access: 'home'
}
 }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
